import { render, staticRenderFns } from "./AssetTypeAddForm.vue?vue&type=template&id=b9d40580"
import script from "./AssetTypeAddForm.vue?vue&type=script&lang=js"
export * from "./AssetTypeAddForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports